export var ProductCardVariantType;
(function (ProductCardVariantType) {
    /**
     * @deprecated Do not use this variant
     */
    ProductCardVariantType["REGULAR"] = "REGULAR";
    ProductCardVariantType["ACCOUNTS"] = "ACCOUNTS";
    ProductCardVariantType["CREDIT_CARDS"] = "CREDIT_CARDS";
    ProductCardVariantType["DEBIT_CARDS"] = "DEBIT_CARDS";
    ProductCardVariantType["DEPOSITS"] = "DEPOSITS";
    ProductCardVariantType["INSURANCES"] = "INSURANCES";
    ProductCardVariantType["LOANS"] = "LOANS";
    ProductCardVariantType["MORTGAGES"] = "MORTGAGES";
    ProductCardVariantType["WEALTH"] = "WEALTH";
})(ProductCardVariantType || (ProductCardVariantType = {}));
//# sourceMappingURL=variants.js.map